import {put, takeLatest} from "redux-saga/effects";
import {appNotify, fetchStrategies, setStrategies, setIsLoading} from "../store/actions";
import {getWithToken} from "../api/network";

export function* getDashboardStrategiesSaga() {
  yield takeLatest(fetchStrategies, function* () {
    try {
      const type = "strategies";
      yield put(setIsLoading({inventoryType: type, isLoading: true}));

      let url = `/api/dashboard/GetDashboardInventoryChannels`;
      const res = yield getWithToken(url);
      const obj = yield res.json();
      const strategies = yield obj.map(x => x.descriptiveFitOrderNames);

      console.log(`Strategies: `, strategies);

      yield put(setStrategies({strategies, inventoryType: type}));
      yield put(setIsLoading({inventoryType: type, isLoading: false}));
    } catch (error) {
      console.error(error);
      yield put(appNotify(`Failed to fetch strategies: ${error.message}`, 'error'));
    }
  });
}
